export const settingPages = {
  PROFILE_PAGE: 1,
  EDIT_PERSONAL_INFO: 2,
  EDIT_PASSWORD: 3,
  COMPANY_PROFILE: 4,
  EDIT_COMPANY_PROFILE: 5,
  MANAGE_USERS: 6,
  ADD_USER: 7,
};
